module.exports = __webpack_public_path__ + "assets/img/Home.af4556c4-ps.jpg";